import { HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição cujo erro é tratado localmente por quem a disparou e, por isso,
 * NÃO deve abrir o diálogo global de erro do `InterceptorService`.
 *
 * Existe porque o interceptor abre o diálogo para todo `HttpErrorResponse`, antes de o
 * erro chegar ao `catchError` do chamador — um `catchError` com fallback silencioso não
 * consegue, sozinho, evitar que o comprador veja um modal.
 *
 * Use com parcimônia: o default é o diálogo aparecer, e ele deve continuar aparecendo em
 * qualquer requisição cuja falha o usuário precise conhecer. Só suprima quando a falha
 * tiver fallback definido e for irrelevante para quem está na tela.
 *
 * Mora num arquivo próprio, sem dependências, de propósito: declarado no
 * `HttpErrorMessageService` criaria o ciclo de imports
 * `pedido.service` -> `http-error-message.service` -> `pedido-manager` -> `pedido.service`.
 */
export const SUPRIMIR_DIALOGO_ERRO = new HttpContextToken<boolean>(() => false);
